import { render, staticRenderFns } from "./bloqueo.vue?vue&type=template&id=a01c7dfe&scoped=true"
import script from "./bloqueo.vue?vue&type=script&lang=js"
export * from "./bloqueo.vue?vue&type=script&lang=js"
import style0 from "./bloqueo.vue?vue&type=style&index=0&id=a01c7dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01c7dfe",
  null
  
)

export default component.exports